import React from "react";
import "./Breadcrumb.scss";

// Icons used
import { ArrowRight } from "../icons";

const Breadcrumb = ({
  children, // Breadcrumb items (typically <BreadcrumbItem>)
  separator: Icon = ArrowRight, // Icon used as a separator between items
  size = "md", // Size variant of breadcrumb (e.g., sm, md, lg)
  className = "", // Additional custom class names
}) => {
  const childrenArray = React.Children.toArray(children); // Normalize children to array
  const totalItems = childrenArray.length; // Total breadcrumb items

  return (
    <nav
      className={`breadcrumb-wrapper ${size} ${className}`}
      aria-label="breadcrumb"
    >
      <ol className="breadcrumb">
        {childrenArray.map((child, index) => (
          <li className="breadcrumb-item" key={index}>
            {/* Inject 'isLast' prop to last item for styling logic */}
            {React.cloneElement(child, { isLast: index === totalItems - 1 })}

            {/* Render separator icon if not the last item */}
            {index < totalItems - 1 && <Icon size={size} className="" />}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
